import { createSlice } from '@reduxjs/toolkit';

const holidaySlice = createSlice({
  name: 'holiday',
  initialState: {
    rows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const holidayActions = holidaySlice.actions;
export default holidaySlice;